import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlConsultaDiarias = '/service/contabilidade/dotacao/'

class consultaDiariasPassagensService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            exercicio: filtro.exercicio ? filtro.exercicio.value : null,
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value).join() : this.state.adms,
            periodoUtilizacaoInicial: filtro.dataEmpenhoInicial ? moment(filtro.dataEmpenhoInicial).format() : null,
            periodoUtilizacaoFinal: filtro.dataEmpenhoFinal ? moment(filtro.dataEmpenhoFinal).format() : null,
            cargo: filtro.cargo.length > 0 ? filtro.cargo.map(e => e.value).join() : null,
            nomeFavorecido: filtro.nome ? filtro.nome : null,
            cpf: filtro.cpf ? filtro.cpf.replace(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/, '$1$2$3$4') : null,
        }

        return this.conex.post(urlConsultaDiarias + 'consultaDiariasPassagens/', JSON.stringify(data))
    }
}

export default consultaDiariasPassagensService
